import styled from 'styled-components'

const PriceContainer = styled.div``

export { PriceContainer }
